module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 499.2\"><path d=\"M500 499H0V0l500 499z\"></path></svg>"